import cn from 'classnames/bind';
import { useToggleState } from 'hooks';
import Router from 'next/router';
import PropTypes from 'prop-types';
import { Input, Button, ErrorMessage } from 'ui';
import contactService from 'utils/services/contactService';
import contactFormSchema from 'utils/validations/schemas/contact';
import useForm from 'utils/validations/useForm';

import ContactSuccessPopup from './ContactSuccessPopup';

import s from './ContactUsForm.module.scss';

const cx = cn.bind(s);
function getDebugInfo(query = {}) {
  const keys = ['reason', 'target'];
  const keysInQuery = keys.filter((key) => query[key]);
  if (!keysInQuery.length) {
    return null;
  }
  return Object.fromEntries(keysInQuery.map((key) => ([key, query[key]])));
}
const ContactUsForm = ({ children, className, ...attrs }) => {
  const {
    isActive: isSuccessPopupOpen,
    open: openSuccessPopup,
    close: closeSuccessPopup,
  } = useToggleState(false);
  const {
    values, isLoading, errors, getInputProps, submit, reset,
  } = useForm(contactFormSchema);
  const handleSubmit = (ev) => {
    ev.preventDefault();
    submit(async () => {
      await contactService.send({ ...values, debug: getDebugInfo(Router.query) });
      openSuccessPopup();
      reset();
    });
  };
  return (
    <>
      <form className={cx(className, 'form')} noValidate onSubmit={handleSubmit} {...attrs}>
        <div className={cx('formGroup')}>
          <Input
            type="email"
            label="E-mail"
            placeholder="Enter your e-mail"
            {...getInputProps('email')}
          />
        </div>
        <div className={cx('formGroup')}>
          <Input
            type="text"
            label="Name"
            placeholder="Enter your name"
            {...getInputProps('name')}
          />
        </div>
        <div className={cx('formGroup')}>
          <Input
            as="textarea"
            type="text"
            label="Message"
            placeholder="Write your message here"
            {...getInputProps('message')}
          />
        </div>
        {errors._error && <ErrorMessage text={errors._error} />}
        <div className={cx('formAction')}>
          <Button size="large" disabled={isLoading}>
            Send
          </Button>
        </div>
      </form>
      <ContactSuccessPopup isOpen={isSuccessPopupOpen} onClose={closeSuccessPopup} />
    </>
  );
};

ContactUsForm.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ContactUsForm;
